"use strict"; // Listen for clicks

const insights =  () => {
  //document.addEventListener('DOMContentLoaded', function () {
    var navLinks = document.querySelectorAll('.insights-menu__menu .menu-item');
    navLinks.forEach(function (navLink) {
      navLink.addEventListener('click', function (e) {
        handleClick(e, navLinks);
      });
    });
  //}); // Override clicks if fetch is supported & category ID supplied
  
  function handleClick(e, allLinks) {
    if (self.fetch && e.target.dataset.id) {
      e.preventDefault(); // Handle active class change
      e.stopPropagation();
  
      allLinks.forEach(function (navLink) {
        navLink.classList.remove('current-menu-item');
      });
      e.target.parentNode.classList.add('current-menu-item');
      fetchPosts(e.target.dataset.id);
    }
  }
  
  function endpointBuilder(categoryId) {
    return "/nuccobrain/wp-json/wp/v2/posts?categories=".concat(categoryId);
  } // Fetch posts from API
  
  
  function fetchPosts(categoryId) {
    fetch(endpointBuilder(categoryId)).then(function (response) {
      return response.json();
    }).then(function (newPosts) {
      displayPosts(newPosts);
    });
  } // Update the page
  
  
  function displayPosts(newPosts) {
    var ul = document.getElementById('insights-posts');
    console.log(newPosts);
    ul.innerHTML = "";
    newPosts.forEach(function (newPost, i) {
      if (i === 0) {
        ul.innerHTML += "\n                <li class=\"post-card wide\">\n                    <div class=\"post-card__background\" style=\"background-image: url('".concat(newPost.acf_fields.main_image, "')\"></div>\n                    <div class=\"post-card__content\">\n                        <h2 class=\"post-card__headline\">").concat(newPost.title.rendered, "</h2>\n                        <p class=\"post-card__excerpt\">").concat(newPost.acf_fields.subtitle, "</p>\n                        <a class=\"post-card__link\" href=\"").concat(newPost.link, "\">Read more</a>\n                        <a class=\"btn btn--insights\" href=\"").concat(newPost.link, "\">Read more</a>\n                    </div>\n                </li>\n            ");
      } else {
        ul.innerHTML += "\n                <li class=\"post-card\">\n                    <img class=\"post-card__image\" src=\"".concat(newPost.acf_fields.main_image, "\" alt=\"").concat(newPost.title.rendered, "\"/>\n                    <div class=\"post-card__content\">\n                        <h2 class=\"post-card__headline\">").concat(newPost.title.rendered, "</h2>\n                        <p class=\"post-card__excerpt\">").concat(newPost.acf_fields.subtitle, "</p>\n                        <a class=\"post-card__link\" href=\"").concat(newPost.link, "\">Read more</a>\n                        <a class=\"btn btn--insights\" href=\"").concat(newPost.link, "\">Read more</a>\n                        <svg class=\"post-card__caret\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 75 145.3\"><defs><style>.cls-1{fill:#4ab8b7;}</style></defs><title>caret-right</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><polygon class=\"cls-1\" points=\"75 72.65 0 0 0 145.3 75 72.65\"/></g></g></svg>\n                    </div>\n                </li>\n            ");
      }
    });
  }

}

export default insights;
